import styles from './index.module.scss';
import { useFm } from '@web3/base-hooks';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { useButtonStatus } from '@/containers/pool/operation/account/investInfo/hooks';
import { ShowType } from '@/types/account';

interface Props {
  showType: ShowType;
}
/**
 * 只有延迟赎回按钮时才需要展示文案
 * **/
export const DelayRedeemNotify = (props: Props) => {
  const { showType = ShowType.DelayUnStake } = props;

  const fm = useFm();
  const { poolInfo } = usePoolInfoContext();
  const { delayUnStakeIsHidden, delayUnstakeEmergencyDisabled } =
    useButtonStatus();

  if (delayUnStakeIsHidden || delayUnstakeEmergencyDisabled) return null;

  let text =
    poolInfo.chainCode === 'TON'
      ? fm('redemptionSuccessMsg', { time: 72 })
      : fm('endCycleAndCalc');

  // 立即赎回文案
  if (
    showType !== ShowType.DelayUnStake &&
    showType !== ShowType.ConfimDelayUnStake
  ) {
    text = fm('immediateRedemption1');
  }

  return <div className={styles.container}>{text}</div>;
};
